import { createContext, useContext } from "react";

/**
 * An optional action rendered inside the toast. Exists for undo: the moment a mis-click is still in
 * someone's head is the moment the toast is on screen, and a control anywhere else is a control
 * they have to go looking for.
 */
export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastContextValue {
  showSuccess: (message: string, action?: ToastAction) => void;
  showError: (message: string, action?: ToastAction) => void;
  showWarning: (message: string, action?: ToastAction) => void;
  showInfo: (message: string, action?: ToastAction) => void;
}

export const ToastContext = createContext<ToastContextValue | undefined>(
  undefined
);

export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext);
  if (!ctx) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return ctx;
}
